import { useEffect } from "react";
import analytics from "core/utils/analytics";

export default function usePageview(pathname, title) {
  useEffect(() => {
    if (!process.browser) return;

    if (!pathname) {
      return;
    }

    if (!title) {
      return;
    }

    analytics.send({
      hitType: "pageview",
      page: pathname,
      title,
    });
  }, [pathname, title, process.browser]);
}
